import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, { data: _ctx.services }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "Название"
              }),
              _createVNode(_component_el_table_column, {
                prop: "permission",
                label: "Permission"
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}